import type { SidebarSectionLinkButtonComponent } from "@productlane/api/src/browser"
import { cn } from "@productlane/lib/src/cn"
import { Button } from "@productlane/ui"

interface Props {
	component: SidebarSectionLinkButtonComponent
	fullWidth?: boolean
}

export function LinkButtonComponent({ component, fullWidth = false }: Props) {
	return (
		<a
			href={component.url}
			target="_blank"
			rel="noreferrer"
			className={cn("inline-block", fullWidth && "block w-full")}
		>
			<Button
				variant="outline"
				size="sm"
				className={cn("max-w-full px-3", fullWidth && "w-full")}
			>
				<span className="truncate">{component.label}</span>
			</Button>
		</a>
	)
}
